//@dependencies
import PropTypes from "prop-types";
//local imports
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
//styles
import styles from "./Popup.module.scss";
import { Grid2 } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/**
 * Popup variant used by the file-upload flow. Identical to the shared Popup but
 * with layout props (contentClassName / fullWidthContent / fillHeight) needed
 * for the full-height, full-width upload wizard. Kept separate so the shared
 * Popup (used across many pages) stays untouched.
 */
export default function ZipPopup(props) {
  //props and hooks
  const {
    trigger,
    closePopup,
    backPopup,
    children,
    buttons,
    header,
    subHeader,
    subSideHeader,
    image,
    image1,
    tempPlans,
    removed,
    contentClassName,
    fullWidthContent,
    fillHeight,
    ...rest
  } = props;

  return trigger ? (
    <Grid2 {...rest} className={styles.popupContainer}>
      <Grid2 className={styles.containerStyles}>
        <Grid2
          className={`${styles.popupDomainContainer} ${contentClassName || ""}`}
          style={
            fillHeight
              ? { display: "flex", flexDirection: "column" }
              : undefined
          }
        >
          {closePopup ? (
            removed ? (
              ""
            ) : (
              <Grid2
                onClick={() => {
                  closePopup();
                }}
              >
                <CloseIcon className={styles.popupCloseButton} />
              </Grid2>
            )
          ) : (
            ""
          )}

          <Grid2 {...rest} item className={styles.addDomainHeader}>
            {backPopup && (
              <span
                onClick={() => {
                  backPopup();
                }}
                className={styles.popupBackButton}
              >
                <ArrowBackIosNewIcon
                  style={{ height: "30px", width: "20px", cursor: "pointer" }}
                />
              </span>
            )}
            <Grid2 className={styles.header}>{header}</Grid2>
            <Grid2 className={styles.subHeader}>{subHeader}</Grid2>
          </Grid2>
          <Grid2
            className={styles.padding}
            style={{
              ...(fullWidthContent ? { width: "100%" } : {}),
              ...(fillHeight ? { flex: 1, minHeight: 0 } : {}),
            }}
          >
            <Grid2
              style={{
                ...(fullWidthContent ? { width: "100%" } : {}),
                ...(fillHeight
                  ? {
                      flex: 1,
                      minHeight: 0,
                      display: "flex",
                      flexDirection: "column",
                    }
                  : {}),
              }}
            >
              {children}
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  ) : null;
}

//types
ZipPopup.propTypes = {
  trigger: PropTypes.bool,
  closePopup: PropTypes.func,
  backPopup: PropTypes.func,
  children: PropTypes.node,
  header: PropTypes.string,
  subHeader: PropTypes.string,
  subSideHeader: PropTypes.string,
  contentClassName: PropTypes.string,
  fullWidthContent: PropTypes.bool,
  fillHeight: PropTypes.bool,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func,
      text: PropTypes.string,
    })
  ),
};
